import React from "react";
import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";

export default function SectionHeader({ eyebrow, title, description, align = "center" }) {
  const alignment = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewport}
      className={`flex flex-col ${alignment} max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
      {eyebrow && (
        <span className="dm-eyebrow mb-4">
          <span className="h-1.5 w-1.5 rounded-full bg-blue-600" />
          {eyebrow}
        </span>
      )}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-[1.08]">{title}</h2>
      {description && <p className="mt-5 text-base sm:text-lg text-slate-500 leading-relaxed">{description}</p>}
    </motion.div>
  );
}
